export enum ROUTES {
  'HOME' = '/',
  'PORTFOLIO' = '/portfolio',
  'ABOUT' = '/about',
  'CONTACT_US' = '/contact',
  'PROJECT' = '/project',
  'INDUSTRIES' = '/industries',
}
